import { useEffect, useState } from "react";
import "./aim-dialog.scss";

function AimDialog({ data: { aim, appointed }, loc, onSave, onClose }) {
    const [_aim, setAim] = useState("");
    const [_appointed, setAppointed] = useState("");
    useEffect(() => {
        setAim(aim ?? "");
        setAppointed(appointed ?? "");
    }, []); // eslint-disable-line

    const onOkClick = () => {
        const savedData = { aim: _aim, appointed: _appointed };
        onSave(savedData);
        onClose();
    };

    return (
        <div className="popup-window popup-window_opened aim-popup-window">
            <button type="button" className="popup-close-btn" onClick={() => onClose()}>
                &times;
            </button>
            <div>
                <h3 className="form-header">{loc("dialogs.aim.title")}</h3>
                <div className="form-content">
                    <div className="ctrl-container ctrl-container-aim">
                        <div className="ctrl-block">
                            <label htmlFor="edit_aim">{loc("report.exam.aim")}</label>
                            <input
                                id="edit_aim"
                                type="text"
                                className="ctrl-input"
                                value={_aim}
                                onChange={e => {
                                    setAim(e.target.value);
                                }}
                            />
                        </div>

                        <div className="ctrl-block">
                            <label htmlFor="edit_appointed">{loc("report.exam.appointed")}</label>
                            <input
                                id="edit_appointed"
                                type="text"
                                className="ctrl-input"
                                value={_appointed}
                                onChange={e => {
                                    setAppointed(e.target.value);
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="form-footer">
                    <input type="submit" className="button button-ok" value={loc("buttons.ok")} onClick={() => onOkClick()} />
                    <input type="reset" className="button button-cancel" value={loc("buttons.cancel")} onClick={() => onClose()} />
                </div>
            </div>
        </div>
    );
}

export default AimDialog;
